import React from "react"
import Slider from "react-slick"
import { generateRandomString } from "../../helpers/keys"
import useWindowWidth from "../../hooks/useWindowWidth"

export default function ImpressionSliderComponent({ impressionSliderImages }) {
  // might need this later depending on if window width detection will be necessary
  const windowWidth = useWindowWidth()

  //slick slider settings - change these if necessary.
  var settings = {
    arrows: true,
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          arrows: false,
        },
      },
    ],
  }

  const htmlImpressionItems =
    impressionSliderImages?.length > 0
      ? impressionSliderImages.map((item) => {
          return <ImpressionSliderItem key={generateRandomString()} sliderImage={item.sliderImage} />
        })
      : null

  return (
    <div className="impression-slider-container">
      <div className="w--wider">
        <Slider {...settings}>{htmlImpressionItems}</Slider>
      </div>
    </div>
  )
}

function ImpressionSliderItem({ sliderImage }) {
  return (
    <div data-epi-property="ImpressionSliderImages" className="impression-slider-item">
      <img data-epi-property="SliderImage" src={sliderImage} />
    </div>
  )
}
